import { render, staticRenderFns } from "./SalesStatementComponent.vue?vue&type=template&id=b43048d2&scoped=true"
import script from "./SalesStatementComponent.vue?vue&type=script&lang=js"
export * from "./SalesStatementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43048d2",
  null
  
)

export default component.exports